var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AchooColumnChartComponent } from '../achoo-column-chart/achoo-column-chart.component';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
import { UserService } from '../../services/user.service';
var AchooColumnChartPlaceholderComponent = /** @class */ (function (_super) {
    __extends(AchooColumnChartPlaceholderComponent, _super);
    function AchooColumnChartPlaceholderComponent(pdfService, userService) {
        var _this = _super.call(this, pdfService, userService) || this;
        _this.pdfService = pdfService;
        _this.userService = userService;
        _this.fakeItemData = [];
        _this.fakeItemData.push({ name: '1', y: 10, isFaking: true });
        _this.fakeItemData.push({ name: '2', y: 60, isFaking: true });
        _this.fakeItemData.push({ name: '3', y: 40, isFaking: true });
        _this.fakeItemData.push({ name: '4', y: 20, isFaking: true });
        _this.fakeItemData.push({ name: '5', y: 10, isFaking: true });
        _this.chartData = _this.fakeItemData;
        _this.isFallbackView = true;
        return _this;
    }
    return AchooColumnChartPlaceholderComponent;
}(AchooColumnChartComponent));
export { AchooColumnChartPlaceholderComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-column-chart-placeholder/achoo-column-chart-placeholder.component.ts.pre-build-optimizer.js